
import React, { useState, useEffect } from "react";
import {
  Grid,
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Paper,
  MenuItem,
  ImageList,
  ImageListItem,
  Snackbar,
  Alert,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from "@mui/material";
import { vendorApi } from "../api/api";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { investorApi } from "../api/api";
import moment from "moment";
import GradientButton from "../components/common/GradiantButton";
import Loader from "../components/common/Loader";


const AddProperty = () => {
  const isVerified = useSelector((state) => state.user.isVerified);

  const propertyTypes = [{ value: "property", label: "Land / Plot" },
  { value: "project", label: "Project Plots" },
  { value: "Individual Villa", label: "Individual House/Villa" },
  { value: "Apartment", label: "Apartment Flats" }
  ];
  const [error, setError] = useState("");
  const isSubscribed = useSelector((state) => state.user.isSubscribed);
  const [form, setForm] = useState({
    propertyType: "",
    propertyName: "",
    city: "",
    address: "",
    facing: "",
    NoOfPlots: "",
    sizeInSqft: "",
    sqftPrice: "",
    lat: "",
    lng: "",
  });
  const [totalArea, setTotalArea] = useState(0);
  const [plotFloor, setPlotFloor] = useState(0);
  const [plotName, setPlotName] = useState("");
  const [bedroomcount, setBedRoomCount] = useState(0);
  const [bathroomcount, setBathRoomCount] = useState(0);
  const [parking, setParking] = useState("yes");
  const [landarea, setLandArea] = useState("");
  const [noofFloors, setNoOfFloors] = useState(0);
  const [parkingType, setParkingType] = useState("bike");
  const [ageOfBuilding, setAgeOfBuilding] = useState(0);
  const [waterSupply, setWaterSupply] = useState("");
  const [balcony, setBalcony] = useState(0);
  const [powerBackup, setPowerBackup] = useState("");
  const [totalPrice, setTotalPrice] = useState(0);
  const [open, setOpen] = useState(false);
  const userId = useSelector((state) => state.user.userId);
  const navigation = useNavigate();
  const [displayPicture, setDisplayPicture] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]);
  const [message, setMessage] = useState("");
  const [messageColor, setMessageColor] = useState("green");
  const [loading, setLoading] = useState(true);
  const [security, setSecurity] = useState("");
  const [cctv, setCctv] = useState("");
  const [lift, setLift] = useState("");
  const [maintenance, setMaintenance] = useState(0);
  const [layoutPicture, setLayoutPicture] = useState(null);
  const [showSubscriptionDialog, setShowSubscriptionDialog] = useState(false);
  const [subscription, setSubscription] = useState(null);
  const [showLimitPopup, setShowLimitPopup] = useState(false);
  const [limitMessage, setLimitMessage] = useState('');
  const [dialogType, setDialogType] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);

  const [showPlanStatusDialog, setShowPlanStatusDialog] = useState(false);
  const [planStatusMessage, setPlanStatusMessage] = useState("");
  const [amenities, setAmenities] = useState([
    { name: "" }
  ]);
  const [description, setDescription] = useState("");
  const [constructionStatus, setConstructionStatus] = useState("");



  const [priceMode, setPriceMode] = useState(""); // percentage | sqft
  const [extraValue, setExtraValue] = useState("");
  const [calculatedAmount, setCalculatedAmount] = useState(0);


  const basePrice =
    Number(form.sizeInSqft || 0) * Number(form.sqftPrice || 0);


  const effectivePrice =
    form.propertyType === "property"
      ? basePrice
      : Number(totalPrice || 0);


  useEffect(() => {
    if (!extraValue || !effectivePrice) {
      setCalculatedAmount(0);
      return;
    }

    if (priceMode === "percentage") {
      setCalculatedAmount((effectivePrice * Number(extraValue)) / 100);
    }

    if (priceMode === "sqft") {
      setCalculatedAmount(
        Number(extraValue) * Number(form.sizeInSqft || 0)
      );
    }
  }, [priceMode, extraValue, effectivePrice, form.sizeInSqft]);

  /* -------- Amenities -------- */
  const handleAmenityChange = (index, value) => {
    const updated = [...amenities];
    updated[index].name = value;
    setAmenities(updated);
  };

  const addAmenity = () =>
    setAmenities([...amenities, { name: "" }]);

  const removeAmenity = (index) => {
    const updated = amenities.filter((_, i) => i !== index);
    setAmenities(updated.length ? updated : [{ name: "" }]);
  };


  const theme = useSelector((state) => state.themeValue.colors);




  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedForm = { ...form, [name]: value };
    if (name === "sizeInSqft" || name === "sqftPrice") {
      const size = parseFloat(updatedForm.sizeInSqft) || 0;
      const price = parseFloat(updatedForm.sqftPrice) || 0;
      updatedForm.originalPropertyValue = size * price;
    }
    setForm(updatedForm);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const checkSubscription = async () => {
      try {
        const res = await investorApi.getSubscriptionsById(userId);

        setSubscription(res.data); // even for Free plan
        setLoading(false);

        const sub = res.data.subscription;
        setSubscription(res.data);

        const endDate = moment(sub.end_date);
        const today = moment();

        // Subscription exists but not usable
        if (sub.status !== "Active" || today.isAfter(endDate)) {
          setPlanStatusMessage(
            sub.status === "Pending"
              ? "Your subscription is pending approval."
              : sub.status === "Rejected"
                ? "Your subscription was rejected."
                : "Your subscription has expired."
          );
          setShowPlanStatusDialog(true);
          setLoading(false);
          return;
        }

        // Active subscription → OK
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    };

    checkSubscription();
  }, [userId]);




  const checkLimits = (selectedType) => {
    if (!subscription) return;

    const {
      plan_name,
      within_property_limit,
      within_project_limit,
    } = subscription;

    // 🚫 Project limit reached
    if (selectedType === "project" && !within_project_limit) {
      setLimitMessage(
        plan_name === "Free"
          ? "Free plan limit reached (1 project). Upgrade to add more."
          : `Your ${plan_name} plan project limit reached. Upgrade to continue.`
      );
      setShowLimitPopup(true);
      return;
    }

    // 🚫 Property limit reached
    if (selectedType !== "project" && !within_property_limit) {
      setLimitMessage(
        plan_name === "Free"
          ? "Free plan limit reached (2 properties). Upgrade to add more."
          : `Your ${plan_name} plan property limit reached. Upgrade to continue.`
      );
      setShowLimitPopup(true);
      return;
    }
  };



  const handleLayoutImageChange = (e) => {
    const file1 = e.target.files[0];
    if (file1) {
      setLayoutPicture(file1);
    }
  };

  const handleDisplayImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setDisplayPicture(file);
    }
  };

  const handleGalleryImagesChange = (e) => {
    const files = Array.from(e.target.files);
    const updatedGallery = [...galleryImages, ...files];

    if (updatedGallery.length < 3) {
      setError("Please upload at least three images.");
    } else {
      setError("");
    }

    setGalleryImages(updatedGallery);
  };


  const handleSelect = ({ lat, lng }) =>
    setForm((p) => ({ ...p, lat, lng }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);

    // --- General validation ---
    if (
      !form.propertyType ||
      !form.propertyName ||
      !form.city ||
      !form.address ||
      (
        form.propertyType !== "project" &&
        form.propertyType !== "Apartment" &&
        !form.facing
      ) ||
      !displayPicture
    ) {
      setMessage(
        form.propertyType === "project" || form.propertyType === "Apartment"
          ? "Please fill all required fields and upload display picture."
          : "Please fill all required fields including facing and upload display picture."
      );
      setMessageColor("red");
      setOpen(true);
      setSubmitLoading(false);
      return;
    }

    // --- Type-specific validation ---
    let missingFields = [];

    switch (form.propertyType) {
      case "project":
        if (!layoutPicture) missingFields.push("Layout picture");
        if (!form.NoOfPlots) missingFields.push("Number of plots");
        if (!totalArea) missingFields.push("Total Area");
        break;

      case "property":
        if (!form.sizeInSqft) missingFields.push("Size in sq ft");
        if (!form.sqftPrice) missingFields.push("Price per sq ft");
        break;

      case "Individual Villa":
        if (!totalPrice) missingFields.push("Total price");
        if (!form.sizeInSqft) missingFields.push("Size in sq ft");
        if (!bedroomcount) missingFields.push("Number of bedrooms");
        if (!bathroomcount) missingFields.push("Number of bathrooms");
        if (!landarea) missingFields.push("Land area");
        if (!noofFloors) missingFields.push("Number of floors");
        if (!waterSupply) missingFields.push("Water supply");
        if (!powerBackup) missingFields.push("Power backup");
        if (!ageOfBuilding) missingFields.push("Age of building");
        if (!balcony) missingFields.push("Balcony info");
        if (parking === "yes" && !parkingType) missingFields.push("Parking type");
        break;

      case "Apartment":
        // if (!form.sizeInSqft) missingFields.push("Size in sq ft");
        // if (!plotName) missingFields.push("Plot name");
        // if (!totalPrice) missingFields.push("Total price");
        if (!landarea) missingFields.push("Land area");
        if (!noofFloors) missingFields.push("TotalFloors");
        if (!form.NoOfPlots) missingFields.push("Number of plots");
        // if (!bedroomcount) missingFields.push("Number of bedrooms");
        // if (!bathroomcount) missingFields.push("Number of bathrooms");
        // if (!waterSupply) missingFields.push("Water supply");
        // if (!powerBackup) missingFields.push("Power backup");
        // if (!ageOfBuilding) missingFields.push("Age of building");
        // if (!balcony) missingFields.push("Balcony info");
        // if (!lift) missingFields.push("Lift availability");
        // if (!security) missingFields.push("Gated security");
        // if (!cctv) missingFields.push("CCTV availability");
        // if (!maintenance) missingFields.push("Maintenance charges");
        // if (parking === "yes" && !parkingType) missingFields.push("Parking type");
        break;

      default:
        break;
    }

    if (missingFields.length > 0) {
      setMessage(`Please fill the following fields: ${missingFields.join(", ")}`);
      setMessageColor("red");
      setOpen(true);
      setSubmitLoading(false); // Add here
      return;
    }

    // --- If validation passes, prepare formData ---
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("PropertyType", form.propertyType);
    formData.append("PropertyName", form.propertyName);
    formData.append("City", form.city);
    formData.append("Address", form.address);
    formData.append("Facing", form.facing);

    if (form.propertyType === "project") {
      formData.append("LayoutURL", layoutPicture);
      formData.append("NoOfPlots", form.NoOfPlots);
      formData.append("TotalArea", totalArea);
    } else if (form.propertyType === "property") {
      formData.append("SizeInSqFt", form.sizeInSqft);
      formData.append("SqFtPrice", form.sqftPrice);
    } else if (form.propertyType === "Individual Villa") {
      formData.append("TotalPrice", totalPrice);
      formData.append("SizeInSqFt", form.sizeInSqft);
      const ExtraData = {
        Bedrooms: bedroomcount,
        Bathrooms: bathroomcount,
        ParkingAvailable: parking,
        LandAreaInSqFt: landarea,
        NoOfFloors: noofFloors,
        WaterSupply: waterSupply,
        PowerBackUp: powerBackup,
        AgeOfBuilding: ageOfBuilding,
        Balcony: balcony
      };
      if (parking === "yes") {
        ExtraData.ParkingType = parkingType;
      }
      formData.append("ExtraData", JSON.stringify(ExtraData));
    } else if (form.propertyType === "Apartment") {
      formData.append("SizeInSqFt", form.sizeInSqft);
      formData.append("ApartmentName", form.propertyName);
      formData.append("TotalUnits", form.NoOfPlots);
      formData.append("PlotName", plotName);
      formData.append("TotalPrice", totalPrice);
      formData.append("LandArea", landarea);
      formData.append("TotalFloors", noofFloors);
      formData.append("ConstructionStatus", constructionStatus);



      formData.append(
        "Amenities",
        JSON.stringify(
          amenities
            .filter(a => a.name && a.name.trim() !== "")
            .map(a => ({
              name: a.name.trim()
            }))
        )
      );
    }

    formData.append("iconUrl", displayPicture);
    galleryImages.forEach((img) => {
      formData.append("images[]", img);
    });

    formData.append("Description", description);
    formData.append("PriceMode", priceMode);        // percentage | sqft
    formData.append("ExtraValue", extraValue);      // 10 OR 200
    // formData.append("ExtraAmount", calculatedAmount);
    // --- API call ---
    try {
      
      // console.log("PriceMode:", formData.get("PriceMode"));
      // console.log("ExtraValue:", formData.get("ExtraValue"));
      // console.log("ExtraAmount:", formData.get("ExtraAmount"));

      const response = await vendorApi.addPropertyByVendorId(formData);
 
      if (response.status === 200) {
        setMessage("Property added successfully!");
        setMessageColor("green");
        setOpen(true);

        // Reset form fields
        setForm({
          propertyType: "",
          propertyName: "",
          city: "",
          address: "",
          NoOfPlots: "",
          sizeInSqft: "",
          sqftPrice: "",
        });

        // Reset all other state variables
        setDisplayPicture(null);
        setGalleryImages([]);
        setLayoutPicture(null);
        setTotalPrice("");
        setPlotName("");
        setBedRoomCount("");
        setBathRoomCount("");
        setParking("");
        setParkingType("");
        setLandArea("");
        setNoOfFloors("");
        setWaterSupply("");
        setPowerBackup("");
        setAgeOfBuilding("");
        setBalcony("");
        setLift("");
        setSecurity("");
        setCctv("");
        setMaintenance("");
        setError("");
      }


    } catch (error) {
      console.error(error);
      setMessage("Failed to add property. Please try again.");
      setMessageColor("red");
      setOpen(true);
    } finally {
      setSubmitLoading(false);
    }
  };

  if (loading) {
    return (
      <Loader />
    )
  }

  return (
    <Container maxWidth="md" sx={{ mt: 5, minHeight: "100vh" }}>
      {!isVerified ? (
        <Paper sx={{ p: 4, borderRadius: 3, textAlign: "center" }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Your account is not verified.
          </Typography>
          <Typography sx={{ mb: 2 }}>
            Please verify your email or contact support to add a property.
          </Typography>
          <GradientButton
            onClick={() => navigation("/myprofile")}
            text="Go to Profile"
            width={{ xs: "100%", sm: "auto" }}
          />

          {/* <Button
        variant="contained"
        onClick={() => navigation("/myprofile")}
      >
        Go to Profile
      </Button> */}
        </Paper>
      ) : (
        <>
          <Dialog
            open={showSubscriptionDialog}
            onClose={() => {
              setShowSubscriptionDialog(false);
              navigation("/VendorSubscription");
            }}
            PaperProps={{
              sx: {
                width: 400,
                padding: 3,
                textAlign: 'center',
              },
            }}
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
              },
            }}
          >
            <DialogTitle>
              Subscritpion Required
            </DialogTitle>

            <DialogContent>
              "Please subscribe to a plan to upload your property.

            </DialogContent>

            <DialogActions sx={{ justifyContent: 'center' }}>
              <GradientButton
                width="100%"
                onClick={() => {
                  setShowSubscriptionDialog(false);

                  navigation("/SubscriptionPlans", { replace: true });

                }}

                text={"View Plans"}
              />
            </DialogActions>
          </Dialog>


          {/* Main Form */}
          {!loading ? (
            <Paper sx={{ p: 4, borderRadius: 3, backgroundColor: theme.background }}>
              <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: theme.text }}>
                Add New Property
              </Typography>

              {/* Inline Message Display */}
              {/* {message && (
            <Typography sx={{ mb: 2, color: messageColor }}>{message}</Typography>
          )} */}

              <Snackbar open={open}
                autoHideDuration={4000}
                onClose={() => setOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
                <Alert onClose={() => setOpen(false)}
                  severity={messageColor == "green" ? "success" : "error"} sx={{ width: "100%" }}>
                  {message}
                </Alert>

              </Snackbar>
              <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{ display: "flex", flexDirection: "column", gap: 3 }}
              >
                <Box sx={{ display: "flex", alignItems: { sm: "center" }, flexDirection: { xs: "column", sm: "row" }, gap: { xs: 1, sm: 1 } }}>
                  <Typography sx={{ color: theme.text }}>
                    Select Your Property Type :
                  </Typography>
                  {propertyTypes.map(({ value, label }) => (
                    <Button
                      key={value}
                      variant={form.propertyType === value ? 'contained' : 'outlined'}
                      onClick={() => {
                        handleChange({
                          target: {
                            name: 'propertyType',
                            value,
                          },
                        })
                        checkLimits(value);
                      }}
                      sx={{
                        textTransform: 'none',
                        fontSize: '0.85rem',
                        padding: '4px 12px',
                        color: form.propertyType === value ? '#fff' : theme.text,
                        borderColor: theme.text,
                        backgroundColor: form.propertyType === value ? theme.primary_color : 'transparent',
                        '&:hover': {
                          backgroundColor: form.propertyType === value ? theme.primary_color : '#f0f0f0',
                        },
                      }}
                    >
                      {label}
                    </Button>
                  ))}

                </Box>

                <TextField
                  label={
                    form.propertyType === "project" ? "Project Name" : (form.propertyType === "property" || form.propertyType === "Individual Villa") ? "Property Name"
                      : form.propertyType === "Apartment" ? "Apartment Name" : ""
                  }
                  name="propertyName"
                  value={form.propertyName}
                  onChange={handleChange}
                  required
                  sx={{
                    mb: 3,
                    input: {
                      color: theme.text,
                    },
                    label: {
                      color: theme.text,
                    },
                    '& label.Mui-focused': {
                      color: theme.primary_color,
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: theme.text,
                      },
                      '&:hover fieldset': {
                        borderColor: theme.primary_color,
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: theme.primary_color,
                      },
                    },
                  }}
                />

                <TextField
                  label="City"
                  name="city"
                  value={form.city}
                  onChange={handleChange}
                  required
                  sx={{
                    mb: 3,
                    input: {
                      color: theme.text,
                    },
                    label: {
                      color: theme.text,
                    },
                    '& label.Mui-focused': {
                      color: theme.primary_color,
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: theme.text,
                      },
                      '&:hover fieldset': {
                        borderColor: theme.primary_color,
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: theme.primary_color,
                      },
                    },
                  }}
                />
                <TextField
                  label="Address"
                  name="address"
                  value={form.address}
                  onChange={handleChange}
                  required
                  sx={{
                    mb: 3,
                    input: {
                      color: theme.text,
                    },
                    label: {
                      color: theme.text,
                    },
                    '& label.Mui-focused': {
                      color: theme.primary_color,
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: theme.text,
                      },
                      '&:hover fieldset': {
                        borderColor: theme.primary_color,
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: theme.primary_color,
                      },
                    },
                  }}
                />

                {/* <p>Select location on map:</p>
      <LocationPicker onSelect={handleSelect} /> */}

                {/* PROJECT */}



                {form.propertyType === "project" || form.propertyType === "Apartment" ? (
                  <>
                    {form.propertyType === "project" && (
                      <>
                        <TextField
                          label="Number of Plots"
                          name="NoOfPlots"
                          value={form.NoOfPlots}
                          onChange={handleChange}
                          sx={{
                            mb: 3,
                            input: {
                              color: theme.text,
                            },
                            label: {
                              color: theme.text,
                            },
                            '& label.Mui-focused': {
                              color: theme.primary_color,
                            },
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: theme.text,
                              },
                              '&:hover fieldset': {
                                borderColor: theme.primary_color,
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: theme.primary_color,
                              },
                            },
                          }}
                        />

                        <TextField
                          label="Total Area"
                          name="totalArea"
                          value={totalArea}
                          onChange={(e) => setTotalArea(e.target.value)}
                          sx={{
                            mb: 3,
                            input: {
                              color: theme.text,
                            },
                            label: {
                              color: theme.text,
                            },
                            '& label.Mui-focused': {
                              color: theme.primary_color,
                            },
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: theme.text,
                              },
                              '&:hover fieldset': {
                                borderColor: theme.primary_color,
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: theme.primary_color,
                              },
                            },
                          }}
                        />
                      </>
                    )}

                    {/* APARTMENT */}
                    {form.propertyType === "Apartment" && (
                      <>
                        <TextField
                          label="Total Area"
                          name="landarea"
                          value={landarea}
                          onChange={(e) => setLandArea(e.target.value)}
                          sx={{
                            mb: 3,
                            input: {
                              color: theme.text,
                            },
                            label: {
                              color: theme.text,
                            },
                            '& label.Mui-focused': {
                              color: theme.primary_color,
                            },
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: theme.text,
                              },
                              '&:hover fieldset': {
                                borderColor: theme.primary_color,
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: theme.primary_color,
                              },
                            },
                          }}
                        />

                        <TextField
                          label="Total No of Flats"
                          name="NoOfPlots"
                          value={form.NoOfPlots}
                          onChange={handleChange}
                          sx={{
                            mb: 3,
                            input: {
                              color: theme.text,
                            },
                            label: {
                              color: theme.text,
                            },
                            '& label.Mui-focused': {
                              color: theme.primary_color,
                            },
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: theme.text,
                              },
                              '&:hover fieldset': {
                                borderColor: theme.primary_color,
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: theme.primary_color,
                              },
                            },
                          }}
                        />
                        <TextField
                          label="Total No of Floors"
                          name="noofFloors"
                          value={noofFloors}
                          onChange={(e) => setNoOfFloors(e.target.value)}
                          sx={{
                            mb: 3,
                            input: {
                              color: theme.text,
                            },
                            label: {
                              color: theme.text,
                            },
                            '& label.Mui-focused': {
                              color: theme.primary_color,
                            },
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor: theme.text,
                              },
                              '&:hover fieldset': {
                                borderColor: theme.primary_color,
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: theme.primary_color,
                              },
                            },
                          }}
                        />
                        {/* Construction Status */}
                        <Grid item xs={12}>
                          <TextField select label="Construction Status" fullWidth value={constructionStatus} onChange={e => setConstructionStatus(e.target.value)}>
                            <MenuItem value="Planning">Planning</MenuItem>
                            <MenuItem value="Under Construction">Under Construction</MenuItem>
                            <MenuItem value="Ready to Move">Ready to Move</MenuItem>
                          </TextField>
                        </Grid>



                        {/* AMENITIES */}
                        <Grid item xs={12}>
                          <Typography variant="h6">Amenities</Typography>
                        </Grid>

                        {amenities.map((a, i) => (
                          <Grid item xs={12} key={i}>
                            <Box display="flex" gap={2}>
                              <TextField
                                label={`Amenity ${i + 1}`}
                                fullWidth
                                value={a.name}
                                onChange={(e) => handleAmenityChange(i, e.target.value)}
                              />
                              {amenities.length > 1 && (
                                <Button color="error" onClick={() => removeAmenity(i)}>
                                  Remove
                                </Button>
                              )}
                            </Box>
                          </Grid>
                        ))}


                        <Grid item xs={12}>
                          <Button variant="outlined" onClick={addAmenity}>
                            + Add Amenity
                          </Button>
                        </Grid>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <TextField
                      label="Facing"
                      name="facing"
                      value={form.facing}
                      onChange={handleChange}
                      required
                      sx={{
                        mb: 3,
                        input: {
                          color: theme.text,
                        },
                        label: {
                          color: theme.text,
                        },
                        '& label.Mui-focused': {
                          color: theme.primary_color,
                        },
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: theme.text,
                          },
                          '&:hover fieldset': {
                            borderColor: theme.primary_color,
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: theme.primary_color,
                          },
                        },
                      }}
                    />
                    <TextField
                      label="Size in SqFt"
                      name="sizeInSqft"
                      value={form.sizeInSqft}
                      onChange={handleChange}
                      sx={{
                        mb: 3,
                        input: {
                          color: theme.text,
                        },
                        label: {
                          color: theme.text,
                        },
                        '& label.Mui-focused': {
                          color: theme.primary_color,
                        },
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: theme.text,
                          },
                          '&:hover fieldset': {
                            borderColor: theme.primary_color,
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: theme.primary_color,
                          },
                        },
                      }}
                    />
                    {form.propertyType === "property" && (
                      <TextField
                        label="SqFt Price"
                        name="sqftPrice"
                        value={form.sqftPrice}
                        onChange={handleChange}
                        sx={{
                          mb: 3,
                          input: {
                            color: theme.text,
                          },
                          label: {
                            color: theme.text,
                          },
                          '& label.Mui-focused': {
                            color: theme.primary_color,
                          },
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor: theme.text,
                            },
                            '&:hover fieldset': {
                              borderColor: theme.primary_color,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: theme.primary_color,
                            },
                          },
                        }}
                      />
                    )}
                  </>
                )}
                {(form.propertyType === "property" || form.propertyType === "Individual Villa" || form.propertyType === "Apartment") && (
                  <Grid
                    container
                    spacing={2}
                    sx={{
                      width: "100%",
                      justifyContent: "space-between",
                    }}
                  >
                    {/* Price Mode */}
                    <Grid item xs={12} sm={6} sx={{width:{xs:"100%",sm:"47%"}}}>
                      <TextField
                        select
                        label="Commission Type"
                        fullWidth
                        value={priceMode}
                        onChange={(e) => {
                          setPriceMode(e.target.value);
                          setExtraValue("");
                          setCalculatedAmount(0);
                        }}
                      >
                        <MenuItem value="percentage">Percentage (%)</MenuItem>
                        <MenuItem value="sqft">Per Sq Ft</MenuItem>
                      </TextField>
                    </Grid>

                    {/* Extra Value */}
                    <Grid item xs={12} sm={6} sx={{width:{xs:"100%",sm:"47%"}}}>
                      <TextField
                        label={
                          priceMode === "percentage"
                            ? "Percentage (%)"
                            : priceMode === "sqft"
                              ? "Amount per Sq Ft"
                              : "Extra Value"
                        }
                        type="number"
                        fullWidth
                        disabled={!priceMode}
                        value={extraValue}
                        onChange={(e) => setExtraValue(e.target.value)}
                      />
                    </Grid>

                    {/* Optional preview */}
                    {calculatedAmount > 0 && (
                      <Grid item xs={12}>
                        <Typography sx={{ fontWeight: 600, color: "green" }}>
                          Extra Amount: ₹ {Number(calculatedAmount).toLocaleString("en-IN")}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                )}




                {(form.propertyType === "Individual Villa") && (
                  <Grid item xs={12}>
                    <TextField
                      label="Property Price"
                      fullWidth
                      type="number"
                      value={totalPrice}
                      onChange={(e) => setTotalPrice(e.target.value)}
                      sx={{
                        mb: 3,
                        input: {
                          color: theme.text,
                        },
                        label: {
                          color: theme.text,
                        },
                        '& label.Mui-focused': {
                          color: theme.primary_color,
                        },
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: theme.text,
                          },
                          '&:hover fieldset': {
                            borderColor: theme.primary_color,
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: theme.primary_color,
                          },
                        },
                      }}

                    />
                  </Grid>

                )}

                {(form.propertyType === "Individual Villa") && (
                  <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: 2,
                      mb: 3,
                    }}
                  >
                    <Box sx={{ flex: '1 1 48%' }}>
                      <TextField
                        label="No. of Bedrooms"
                        fullWidth
                        type="number"
                        value={bedroomcount}
                        onChange={(e) => setBedRoomCount(e.target.value)}
                        sx={{
                          input: { color: theme.text },
                          label: { color: theme.text },
                          '& label.Mui-focused': { color: theme.primary_color },
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: theme.text },
                            '&:hover fieldset': { borderColor: theme.primary_color },
                            '&.Mui-focused fieldset': { borderColor: theme.primary_color },
                          },
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: '1 1 48%' }}>
                      <TextField
                        label="No. of Bathrooms"
                        fullWidth
                        type="number"
                        value={bathroomcount}
                        onChange={(e) => setBathRoomCount(e.target.value)}
                        sx={{
                          input: { color: theme.text },
                          label: { color: theme.text },
                          '& label.Mui-focused': { color: theme.primary_color },
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: theme.text },
                            '&:hover fieldset': { borderColor: theme.primary_color },
                            '&.Mui-focused fieldset': { borderColor: theme.primary_color },
                          },
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: '1 1 48%' }}>
                      <TextField
                        select
                        label="Parking Available"
                        fullWidth
                        value={parking}
                        onChange={(e) => setParking(e.target.value)}
                        sx={{
                          input: { color: theme.text },
                          label: { color: theme.text },
                          '& label.Mui-focused': { color: theme.primary_color },
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: theme.text },
                            '&:hover fieldset': { borderColor: theme.primary_color },
                            '&.Mui-focused fieldset': { borderColor: theme.primary_color },
                          },
                        }}
                      >
                        <MenuItem value="yes">Yes</MenuItem>
                        <MenuItem value="no">No</MenuItem>
                      </TextField>
                    </Box>
                    <Box sx={{ flex: '1 1 48%' }}>
                      {parking === "yes" && (
                        <TextField
                          select
                          label="Parking Type"
                          fullWidth
                          value={parkingType}
                          onChange={(e) => setParkingType(e.target.value)}
                          sx={{
                            input: { color: theme.text },
                            label: { color: theme.text },
                            '& label.Mui-focused': { color: theme.primary_color },
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': { borderColor: theme.text },
                              '&:hover fieldset': { borderColor: theme.primary_color },
                              '&.Mui-focused fieldset': { borderColor: theme.primary_color },
                            },
                          }}
                        >
                          <MenuItem value="car">Car</MenuItem>
                          <MenuItem value="bike">Bike</MenuItem>
                          <MenuItem value="both">Both</MenuItem>
                        </TextField>
                      )}
                    </Box>
                    <Box sx={{ flex: '1 1 48%' }}>
                      <TextField
                        label="Land Area"
                        fullWidth
                        value={landarea}
                        onChange={(e) => setLandArea(e.target.value)}
                        sx={{
                          input: { color: theme.text },
                          label: { color: theme.text },
                          '& label.Mui-focused': { color: theme.primary_color },
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: theme.text },
                            '&:hover fieldset': { borderColor: theme.primary_color },
                            '&.Mui-focused fieldset': { borderColor: theme.primary_color },
                          },
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: '1 1 48%' }}>
                      <TextField
                        label="Total No. of Floors"
                        fullWidth
                        type="number"
                        value={noofFloors}
                        onChange={(e) => setNoOfFloors(e.target.value)}
                        sx={{
                          input: { color: theme.text },
                          label: { color: theme.text },
                          '& label.Mui-focused': { color: theme.primary_color },
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: theme.text },
                            '&:hover fieldset': { borderColor: theme.primary_color },
                            '&.Mui-focused fieldset': { borderColor: theme.primary_color },
                          },
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: '1 1 48%' }}>
                      <TextField
                        label="Age of Building"
                        fullWidth
                        type="number"
                        value={ageOfBuilding}
                        onChange={(e) => setAgeOfBuilding(e.target.value)}
                        sx={{
                          input: { color: theme.text },
                          label: { color: theme.text },
                          '& label.Mui-focused': { color: theme.primary_color },
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: theme.text },
                            '&:hover fieldset': { borderColor: theme.primary_color },
                            '&.Mui-focused fieldset': { borderColor: theme.primary_color },
                          },
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: '1 1 48%' }}>
                      <TextField
                        label="Balcony"
                        fullWidth
                        type="number"
                        value={balcony}
                        onChange={(e) => setBalcony(e.target.value)}
                        sx={{
                          input: { color: theme.text },
                          label: { color: theme.text },
                          '& label.Mui-focused': { color: theme.primary_color },
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: theme.text },
                            '&:hover fieldset': { borderColor: theme.primary_color },
                            '&.Mui-focused fieldset': { borderColor: theme.primary_color },
                          },
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: '1 1 48%' }}>
                      <TextField
                        label="Power Backup"
                        fullWidth
                        value={powerBackup}
                        onChange={(e) => setPowerBackup(e.target.value)}
                        sx={{
                          input: { color: theme.text },
                          label: { color: theme.text },
                          '& label.Mui-focused': { color: theme.primary_color },
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: theme.text },
                            '&:hover fieldset': { borderColor: theme.primary_color },
                            '&.Mui-focused fieldset': { borderColor: theme.primary_color },
                          },
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: '1 1 48%' }}>
                      <TextField
                        label="Water Supply"
                        fullWidth
                        value={waterSupply}
                        onChange={(e) => setWaterSupply(e.target.value)}
                        sx={{
                          input: { color: theme.text },
                          label: { color: theme.text },
                          '& label.Mui-focused': { color: theme.primary_color },
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: theme.text },
                            '&:hover fieldset': { borderColor: theme.primary_color },
                            '&.Mui-focused fieldset': { borderColor: theme.primary_color },
                          },
                        }}
                      />
                    </Box>

                  </Box>
                )}
                {form.propertyType === "project" && (
                  <>
                    <Button variant="outlined" component="label">
                      Upload Layout Picture
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={handleLayoutImageChange}
                      />
                    </Button>

                    {layoutPicture && (
                      <Box sx={{ mt: 2, textAlign: "center" }}>
                        <img
                          src={URL.createObjectURL(layoutPicture)}
                          alt="Layout Preview"
                          style={{ width: "100%", maxHeight: 250, objectFit: "cover" }}
                        />
                      </Box>
                    )}
                  </>
                )}

                <Button variant="outlined" component="label">
                  Upload Display Picture
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={handleDisplayImageChange}
                  />
                </Button>

                {displayPicture && (
                  <Box sx={{ mt: 2, textAlign: "center" }}>
                    <img
                      src={URL.createObjectURL(displayPicture)}
                      alt="Display"
                      style={{ width: "100%", maxHeight: 250, objectFit: "cover" }}
                    />
                  </Box>
                )}

                {/* Gallery Upload */}
                <Button variant="outlined" component="label">
                  Upload Gallery Images
                  <input
                    type="file"
                    hidden
                    multiple
                    accept="image/*"
                    onChange={handleGalleryImagesChange}
                  />
                </Button>
                {error && (
                  <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                    {error}
                  </Typography>
                )}


                {galleryImages.length > 0 && (
                  <ImageList cols={3} gap={8}>
                    {galleryImages.map((img, i) => (
                      <ImageListItem key={i}>
                        <img
                          src={URL.createObjectURL(img)}
                          alt={`Gallery-${i}`}
                          loading="lazy"
                        />
                      </ImageListItem>
                    ))}
                  </ImageList>
                )}

                {/* <GradientButton type="submit" variant="contained">
              Submit
            </GradientButton> */}
                <GradientButton
                  type="submit"
                  text={submitLoading ? "Submitting..." : "Submit"}
                  width="100%"
                  disabled={submitLoading}
                />


              </Box>
            </Paper>
          ) : null}
          <Dialog
            open={showLimitPopup}
            onClose={() => {
              setShowLimitPopup(false);             // Auto-close on ESC or backdrop
              navigation("/VendorSubscriptionDetalis"); // Navigate immediately after close
            }}
          >
            <DialogTitle>Limit Reached</DialogTitle>
            <DialogContent>
              <Typography>{limitMessage}</Typography>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setShowLimitPopup(false);
                  navigation("/VendorSubscriptionDetalis");
                }}
                color="secondary"
                variant="outlined"
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  setShowLimitPopup(false);
                  navigation("/SubscriptionPlans");
                }}
                variant="contained"
                color="primary"
              >
                Upgrade Plan
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={showPlanStatusDialog}
            onClose={() => {
              setShowPlanStatusDialog(false);
              navigation("/VendorSubscriptionDetalis", { replace: true });
            }}
            PaperProps={{
              sx: { width: 400, padding: 3, textAlign: "center" }
            }}
          >
            <DialogTitle>Subscription Status</DialogTitle>
            <DialogContent>
              <Typography sx={{ color: "orange" }}>{planStatusMessage}</Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center" }}>
              <GradientButton
                onClick={() => {
                  setShowPlanStatusDialog(false);
                  navigation("/VendorSubscriptionDetalis", { replace: true });
                }}
                text="view details"
              />

            </DialogActions>
          </Dialog>

        </>
      )}
    </Container>
  );
};

export default AddProperty;

// import React, { useState } from "react";
// import {
//   Box,
//   Container,
//   Grid,
//   Typography,
//   Button,
//   Paper,
//   TextField,
//   Stepper,
//   Step,
//   StepLabel,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from "@mui/material";

// const steps = [
//   "Property Type",
//   "Property Details",
//   "Location",
//   "Images",
//   "Submit",
// ];

// const propertyTypes = [
//   { value: "property", label: "Land / Plot" },
//   { value: "project", label: "Project Plots" },
//   { value: "villa", label: "Individual House / Villa" },
//   { value: "apartment", label: "Apartment Flats" },
// ];

// export default function AddProperty() {
//   const isMobile = window.innerWidth < 768;

//   const [activeStep, setActiveStep] = useState(0);

//   const [form, setForm] = useState({
//     propertyType: "",
//     propertyName: "",
//     size: "",
//     price: "",
//     city: "",
//     address: "",
//     plots: "",
//     totalArea: "",
//     bedrooms: "",
//     bathrooms: "",
//     floors: "",
//     landArea: "",
//   });

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleNext = () => {
//     if (activeStep < steps.length - 1) {
//       setActiveStep((p) => p + 1);
//     }
//   };

//   const handleBack = () => {
//     if (activeStep > 0) {
//       setActiveStep((p) => p - 1);
//     }
//   };

//   /* ---------------- STEP CONTENT ---------------- */

//   const renderPropertySpecificFields = () => {
//     switch (form.propertyType) {
//       case "property": // Land
//         return (
//           <>
//             <TextField
//               fullWidth
//               label="Land Size (Sq.ft)"
//               name="size"
//               value={form.size}
//               onChange={handleChange}
//               sx={{ mb: 2 }}
//             />
//             <TextField
//               fullWidth
//               label="Price per Sq.ft"
//               name="price"
//               value={form.price}
//               onChange={handleChange}
//             />
//           </>
//         );

//       case "project":
//         return (
//           <>
//             <TextField
//               fullWidth
//               label="Number of Plots"
//               name="plots"
//               value={form.plots}
//               onChange={handleChange}
//               sx={{ mb: 2 }}
//             />
//             <TextField
//               fullWidth
//               label="Total Area"
//               name="totalArea"
//               value={form.totalArea}
//               onChange={handleChange}
//             />
//           </>
//         );

//       case "villa":
//         return (
//           <>
//             <TextField
//               fullWidth
//               label="Built-up Area (Sq.ft)"
//               name="size"
//               value={form.size}
//               onChange={handleChange}
//               sx={{ mb: 2 }}
//             />
//             <Box sx={{ display: "flex", gap: 2 }}>
//               <TextField
//                 fullWidth
//                 label="Bedrooms"
//                 name="bedrooms"
//                 value={form.bedrooms}
//                 onChange={handleChange}
//               />
//               <TextField
//                 fullWidth
//                 label="Bathrooms"
//                 name="bathrooms"
//                 value={form.bathrooms}
//                 onChange={handleChange}
//               />
//             </Box>
//             <TextField
//               fullWidth
//               label="Total Price"
//               name="price"
//               value={form.price}
//               onChange={handleChange}
//               sx={{ mt: 2 }}
//             />
//           </>
//         );

//       case "apartment":
//         return (
//           <>
//             <TextField
//               fullWidth
//               label="Total Floors"
//               name="floors"
//               value={form.floors}
//               onChange={handleChange}
//               sx={{ mb: 2 }}
//             />
//             <TextField
//               fullWidth
//               label="Total Flats"
//               name="plots"
//               value={form.plots}
//               onChange={handleChange}
//             />
//           </>
//         );

//       default:
//         return null;
//     }
//   };

//   const renderStep = () => {
//     switch (activeStep) {
//       case 0:
//         return (
//           <>
//             <Typography variant="h6" fontWeight={600} gutterBottom>
//               What type of property is it?
//             </Typography>

//             <FormControl fullWidth sx={{ mt: 2 }}>
//               <InputLabel>Property Type</InputLabel>
//               <Select
//                 label="Property Type"
//                 value={form.propertyType}
//                 onChange={(e) =>
//                   setForm({ ...form, propertyType: e.target.value })
//                 }
//               >
//                 {propertyTypes.map((type) => (
//                   <MenuItem key={type.value} value={type.value}>
//                     {type.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </>
//         );

//       case 1:
//         return (
//           <>
//             <Typography variant="h6" fontWeight={600} gutterBottom>
//               Property Details
//             </Typography>

//             <TextField
//               fullWidth
//               label="Property Name"
//               name="propertyName"
//               value={form.propertyName}
//               onChange={handleChange}
//               sx={{ mb: 2 }}
//             />

//             {renderPropertySpecificFields()}
//           </>
//         );

//       case 2:
//         return (
//           <>
//             <Typography variant="h6" fontWeight={600} gutterBottom>
//               Property Location
//             </Typography>

//             <TextField
//               fullWidth
//               label="City"
//               name="city"
//               value={form.city}
//               onChange={handleChange}
//               sx={{ mb: 2 }}
//             />

//             <TextField
//               fullWidth
//               label="Complete Address"
//               name="address"
//               value={form.address}
//               onChange={handleChange}
//               multiline
//               rows={3}
//             />
//           </>
//         );

//       case 3:
//         return (
//           <>
//             <Typography variant="h6" fontWeight={600}>
//               Upload Property Images
//             </Typography>
//             <Typography color="text.secondary">
//               (You can plug your existing gallery logic here)
//             </Typography>
//           </>
//         );

//       case 4:
//         return (
//           <>
//             <Typography variant="h6" fontWeight={600} gutterBottom>
//               Review & Submit
//             </Typography>

//             <Typography>Type: {form.propertyType}</Typography>
//             <Typography>Name: {form.propertyName}</Typography>
//             <Typography>City: {form.city}</Typography>
//           </>
//         );

//       default:
//         return null;
//     }
//   };

//   /* ---------------- DESKTOP LAYOUT ---------------- */

//   if (isMobile) return null; 


//   /* -------------------- MOBILE LAYOUT -------------------- */

//   if (isMobile) {
//     return (
//       <>
//         {/* HEADER */}
//         <Box
//           sx={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             height: 56,
//             bgcolor: "#1976d3",
//             color: "#fff",
//             display: "flex",
//             alignItems: "center",
//             px: 2,
//             zIndex: 1200,
//           }}
//         >
//           <Button onClick={handleBack} sx={{ color: "#fff", mr: 1 }}>
//             ←
//           </Button>
//           <Typography fontWeight={600}>
//             {activeStep + 1}. {steps[activeStep]}
//           </Typography>
//         </Box>

//         {/* CONTENT */}
//         <Box sx={{ pt: 9, pb: 10, px: 2 }}>
//           {renderStep()}
//         </Box>

//         {/* STICKY BUTTON */}
//         <Box
//           sx={{
//             position: "fixed",
//             bottom: 0,
//             left: 0,
//             right: 0,
//             p: 2,
//             bgcolor: "#fff",
//             borderTop: "1px solid #e0e0e0",
//           }}
//         >
//           <Button
//             fullWidth
//             variant="contained"
//             size="large"
//             onClick={handleNext}
//             sx={{
//               bgcolor: "#009688",
//               fontWeight: 600,
//               height: 48,
//               "&:hover": { bgcolor: "#009688" },
//             }}
//           >
//             {activeStep === steps.length - 1
//               ? "Publish Property"
//               : "Save And Continue"}
//           </Button>
//         </Box>
//       </>
//     );
//   }

//   /* -------------------- DESKTOP LAYOUT -------------------- */


//     return (
//   <Container maxWidth="lg" sx={{ mt: 4, mb: 10 }}>

//     <Grid container spacing={3} justifyContent="center">

//   {/* LEFT STEPS */}
//   <Grid
//     item
//     md={3}
//     sx={{
//       position: "sticky",
//       top: 90,
//       maxWidth: 260,
//       flexShrink: 0,
//     }}
//   >
//     <Paper
//       elevation={0}
//       sx={{
//         border: "1px solid #e0e0e0",
//         borderRadius: 2,
//       }}
//     >
//       <Stepper
//         activeStep={activeStep}
//         orientation="vertical"
//         sx={{ p: 2 }}
//       >
//         {steps.map((label) => (
//           <Step key={label}>
//             <StepLabel>{label}</StepLabel>
//           </Step>
//         ))}
//       </Stepper>
//     </Paper>
//   </Grid>

//   {/* RIGHT CONTENT (FIXED WIDTH) */}
//   <Grid
//     item
//     xs={12}
//     md={9}
//     sx={{
//       maxWidth: 820,     // 🔥 FIXED WIDTH LIKE NOBROKER
//       width: "100%",
//     }}
//   >
//     <Paper
//       elevation={0}
//       sx={{
//         border: "1px solid #e0e0e0",
//         borderRadius: 2,
//         p: 4,
//         width: "100%",
//         boxSizing: "border-box",
//       }}
//     >
//       {renderStep()}
//     </Paper>

//     {/* ACTION BAR */}
//     <Box
//       sx={{
//         mt: 3,
//         display: "flex",
//         justifyContent: "space-between",
//       }}
//     >
//       <Button disabled={activeStep === 0} onClick={handleBack}>
//         Back
//       </Button>

//       <Button variant="contained" onClick={handleNext}>
//         Save & Continue
//       </Button>
//     </Box>
//   </Grid>

// </Grid>
// </Container>

// );
// };



